import React from "react";

import "./SalesCard.scss"
import ListView from "./ListView"
import ListView_Newhomes from "./ListView_Newhomes"

const NoStats = ({ properties, img_type, userObjects, search_type }) => {

    //console.log("hits ==>", hits);

    var type_text = search_type === "newhomes" ? "new developments" : "properties";


    //console.log("properties ==>", properties);
    return (
        <>
            {properties?.length > 0 &&
                <>
                    <div className="no-result">
                        <p >Unfortunately, we do not currently have any {type_text} that match your search criteria.</p>
                        <p>We have selected some of our showcase {type_text} for you to browse below. Alternatively, you can search again in the bar above.</p>
                    </div>
                    {properties.map((item, index) => {
                        return (
                            <>
                            {search_type === "newhomes" ? 
                                <ListView_Newhomes item={item} key={index} img_type={img_type} search_type={search_type} userObjects={userObjects} />
                                :
                                <ListView item={item} key={index} img_type={img_type} userObjects={userObjects} />
                            }
                            </>
                        )
                    })}
                </>
                
            }
        </>
    );
};
export default NoStats;
